import axios from "axios";

const getToken = async () => {
  try {
    const token = localStorage.getItem("token");
    return token;
  } catch (error) {
    return null;
  }
};

class Api {
    
    constructor() {
    this.client = null;
    this.api_url = "https://api.electrowiz.in/api";
  

  }

  init = (type) => {

    let headers;

    headers = {
      Accept: "application/json",
    }

    if (type === "multipart/form-data") {
      headers = {
        'Content-Type': 'multipart/form-data',
      }
    }

    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 300000,
      headers: headers,
    });

    this.client.interceptors.request.use(async (config) => {
      const token = await getToken();

      config.headers["Authorization"] = `Bearer ${token}`
      return config;
    }, (error) => {
      throw error;
    })

    // A revoked/expired token must not keep a dashboard session alive. This is
    // what logs out another device after the backend invalidates its token.
    this.client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401 && localStorage.getItem("token")) {
          sessionStorage.setItem("logoutReason", "passwordChanged");
          localStorage.clear();

          if (window.location.pathname !== "/") {
            window.location.assign("/");
          }
        }

        return Promise.reject(error);
      }
    );

    return this.client;
  };


  // login
  login = (data) => {
    return this.init().post("/admin/auth/login", data)
  }

  getDashboarddata = (config) => {
    return this.init().get(`/admin/getDashboardStatistics${config}`)
  }

  //getprofile
  getProfile = () => {
    return this.init().get("/admin/getsingleAdmin")
  }


  //fotgot password send email
  forgotPassword = (data) => {
    return this.init().post("/admin/auth/forgot", data)
  }


  //reset password
  resetPassword = (data) => {
    return this.init().post("/admin/auth/reset", data)
  }

  //upload file
  fileUpload = (data) => {
    return this.init("multipart/form-data").post("/admin/uploadFile", data)
  }

  // asset upload
  assetUpload = (data) => {
    return this.init("multipart/form-data").post("/admin/asset", data)
  }

  // delete asset
  deleteAsset = (id) => {
    return this.init().delete(`/admin/asset/${id}`)
  }

  updateAsset = (data) => {
    return this.init().put(`/admin/asset/${data._id}`, data)
  }

  getAllAsset = (data) => {
    return this.init().get(`/admin/asset${data}`);
  }

  getPutSignedUrl = (data) => {
    return this.init().post("/admin/get-put-url", data)
  }

  //---------------------------------------------------------category---------------------------------------
  //getAllCategory
  getAllCategory = (config) => {
    return this.init().get(`/admin/category${config}`)
  }

  getProductLevel3Categories = () => {
    return this.init().get('/admin/product-level3-categories')
  }

  //bulkAddCategories
  addBulkCategory = (data) => {
    return this.init().post("/admin/bulkCategoryUpload", data)
  }

  addCategory = (data) => {
    return this.init().post("/admin/category", data)
  }

  //delete category
  deleteCategory = (id) => {
    return this.init().delete(`/admin/category/${id}`)
  }

  deletemultipleCategory = (ids) => {
    return this.init().post(`/admin/deleteCategories`, ids)
  }

  //view category
  viewCategory = (id) => {
    return this.init().get(`/admin/category/${id}`)
  }

  updateCategory = (data) => {
    return this.init().put(`/admin/category/${data._id}`, data)
  }

  exportCategory = (config) => {
    return this.init().get(`/admin/exportCategory`)
  }

  // Quick List: fetch supplier data (Mouser / DigiKey) for a list of part numbers
  quickListLookup = (partNumbers, sources) => {
    return this.init().post('/admin/quicklist/lookup', { partNumbers, ...(Array.isArray(sources) && sources.length ? { sources } : {}) }, { timeout: 120000 })
  }

  quickListProviders = () => {
    return this.init().get('/admin/quicklist/providers')
  }

  // Save supplier API keys from the dashboard (stored encrypted on the server)
  quickListSaveSettings = (data) => {
    return this.init().put('/admin/quicklist/settings', data)
  }

  // Look up one part without cache to check the saved keys work
  quickListTest = (partNumber) => {
    return this.init().post('/admin/quicklist/test', { partNumber }, { timeout: 60000 })
  }

  saveQuickProducts = (items) => {
    return this.init().post('/admin/quick-products', { items })
  }

  getQuickProducts = (status = 'PENDING') => {
    return this.init().get(`/admin/quick-products?status=${encodeURIComponent(status)}`)
  }

  updateQuickProduct = (id, data) => {
    return this.init().put(`/admin/quick-products/${id}`, data)
  }

  deleteQuickProduct = (id) => {
    return this.init().delete(`/admin/quick-products/${id}`)
  }

  deleteQuickProducts = (ids) => {
    return this.init().delete('/admin/quick-products', { data: { ids } })
  }

  deleteAllQuickProducts = (password) => {
    return this.init().delete('/admin/quick-products/all', { data: { password } })
  }

  markQuickProductsUploaded = (ids) => {
    return this.init().put('/admin/quick-products/mark-uploaded', { ids })
  }

  bulkuploadProduct = (data) => {
    return this.init().post('/admin/bulkupload/save-product', { products: data }, { timeout: 300000 })
  }


  getAttributesAddProd = (data) => {
    return this.init().get('/admin/getAttributesAddProd')
  }

  getProd = (data) => {
    return this.init().get('/admin/getProducts')
  }

  //-----------------------------------------------------------subcategroy--------------------------------------

  //getAllSubcategory
  getAllSubCategory = (config) => {
    return this.init().get(`/admin/subCategory${config}`)
  }

  //delete subcategory
  deletesubCategory = (id) => {
    return this.init().delete(`/admin/subCategory/${id}`)
  }

  //view subcategory
  viewsubCategory = (id) => {
    return this.init().get(`/admin/subCategory/${id}`)
  }

  //editSubcategory
  updatesubCategory = (data) => {
    return this.init().put(`/admin/subCategory/${data._id}`, data)
  }

  //addsubcategory
  addsubCategory = (data) => {
    return this.init().post("/admin/subcategory", data)
  }

  //bulkAddsubCategories
  addBulksubCategory = (data) => {
    return this.init().post("/admin/bulkUploadSubCategory", data)
  }

  exportSubcategory = (config) => {
    return this.init().get(`/admin/exportSubcategory`)
  }

  //------------------------------------------------level3----------------------------------------------------------------------------

  //getalllevel3
  getAllLevel3 = (config) => {
    return this.init().get(`/admin/level3Subcategory${config}`)
  }

  //bulkAddCategories
  addBulklevel3Category = (data) => {
    return this.init().post("/admin/bulkUploadLevel3Category", data)
  }

  //view subcategory
  viewLevel3 = (id) => {
    return this.init().get(`/admin/level3Subcategory/${id}`)
  }


  //addLevel3
  addLevel3Category = (data) => {
    return this.init().post("/admin/level3Subcategory", data)
  }

  //editSubcategory
  updateLevel3 = (data) => {
    return this.init().put(`/admin/level3Subcategory/${data._id}`, data)
  }

  // Attribute names used by the products of a level 3 category
  getLevel3Attributes = (id) => {
    return this.init().get(`/admin/level3Subcategory/${id}/attributes`)
  }

  exportLevel3 = (config) => {
    return this.init().get(`/admin/exportLevel3subcategory`)
  }

  //-----------------------------------------------------atributes--------------------------------------------

  //getAllAtributes
  getAllAtributes = (config) => {
    return this.init().get(`/admin/atribute${config}`)
  }

  //view aributes
  viewAtribute = (id) => {
    return this.init().get(`/admin/atribute/${id}`)
  }

  //delete atribute
  deleteAtributes = (id) => {
    return this.init().delete(`/admin/atribute/${id}`)
  }

  addAtributes = (data) => {
    return this.init().post("/admin/atribute", data)
  }

  updateAtribute = (data) => {

    return this.init().put(`/admin/atribute/${data._id}`, data)
  }

  addBulkAtribute = (data) => {
    return this.init().post("/admin/bulkUploadAtributes", data)
  }


  exportAtribute = (config) => {
    return this.init().get(`/admin/exportAtribute`)
  }


  deletemultipleAttributes = (ids) => {
    return this.init().post(`/admin/deleteAttributes`, ids)
  }

  //--------------------------------------------------manufacturer-------------------------------------------

  getAllmanufacturer = (config) => {
    return this.init().get(`/admin/manufacturer${config}`)
  }

  getAllWebManufacturer = () => {
    return this.init().get("/admin/get-all-manufacturer")
  }

  exportManufacturer = (config) => {
    return this.init().get('/admin/exportmanufacturer')
  }

  addManufacturer = (data) => {
    return this.init().post("/admin/manufacturer", data)
  }

  //view manufacturer
  viewManufacturer = (id) => {
    return this.init().get(`/admin/manufacturer/${id}`)
  }

  //delete manufacturer
  deleteManufacturer = (id) => {
    return this.init().delete(`/admin/manufacturer/${id}`)
  }

  updateManufacturer = (data) => {
    return this.init().put(`/admin/manufacturer/${data._id}`, data)
  }

  //bulkAddManufacturer
  bulkUploadManufacturer = (data) => {
    return this.init().post("/admin/bulkUploadManufacturer", data)
  }


  deletemultipleManufacturer = (ids) => {
    return this.init().post(`/admin/deleteManufacturers`, ids)
  }

  //-----------------------------------------------------customer---------------------------------------------

  getAllCustomer = (config) => {
    return this.init().get(`/admin/customer${config}`)
  }

  getCustomerDetails = (id) => {
    return this.init().get(`/admin/customer/${id}`)
  }


  rejectOrAproveCustomer = (data) => {

    return this.init().put(`/admin/customerstatus/${data?.id}`, { status: data?.status, admin: data?.selectedAdmin })
  }

  deleteCustomer = (id) => {
    return this.init().delete(`/admin/customer/${id}`)
  }

  addCustomer = (data) => {
    return this.init().post('/admin/customer', data)
  }

  updateCustomer = (data) => {
    return this.init().put(`/admin/customer/${data.id}`, data?.values)
  }

  updateRemarks = (data) => {
    return this.init().put(`/admin/editRemarks/${data.id}`, data?.values)
  }

  exportCustomer = (config) => {
    return this.init().get(`/admin/exportAllCustomer${config}`)
  }

  getAllTypeCustomer = () => {
    return this.init().get(`/admin/getAlltypecustomers`)
  }


  getAllUsers = () => {
    return this.init().get(`/admin/getAllUsers`)
  }

  //----------------------------------------------------vendor---------------------------------------------

  getAllVendor = (config) => {
    return this.init().get(`/admin/vendor${config}`)
  }

  getVendorDetails = (id) => {
    return this.init().get(`/admin/vendor/${id}`)
  }

  rejectOrAproveVendor = (data) => {

    return this.init().put(`/admin/vendorstatus/${data?.id}`, { status: data?.status, admin: data?.selectedAdmin })
  }

  deleteVendor = (id) => {
    return this.init().delete(`/admin/vendor/${id}`)
  }


  addVendor = (data) => {
    return this.init().post('/admin/vendor', data)
  }

  updateVendor = (data) => {
    return this.init().put(`/admin/vendor/${data.id}`, data?.values)
  }


  exportVendor = (config) => {
    return this.init().get(`/admin/exportAllVendors${config}`)
  }


  //------------------------------------------------------product-------------------------------------------

  getAllProduct = (config) => {
    return this.init().get(`/admin/product${config}`)
  }

  exportAllProducts = () => {
    return this.init().get('/admin/product/export', { responseType: 'blob' })
  }

  createProductBackups = (password, selections) => {
    return this.init().post('/admin/product/backups', { password, selections })
  }

  getProductBackups = () => {
    return this.init().get('/admin/product/backups')
  }

  getProductBackupDetails = (id) => {
    return this.init().get(`/admin/product/backups/${id}`)
  }

  restoreProductBackup = (id, password) => {
    return this.init().post(`/admin/product/backups/${id}/restore`, { password })
  }

  deleteProductBackup = (id) => {
    return this.init().delete(`/admin/product/backups/${id}`)
  }

  getProductDetails = (id) => {
    return this.init().get(`/admin/product/${id}`)
  }

  deleteProduct = (id) => {
    return this.init().delete(`/admin/product/${id}`)
  }

  addProduct = (data) => {
    return this.init().post(`/admin/product`, data)
  }

  editProduct = (data) => {
    return this.init().put(`/admin/product/${data?.id}`, data.values)
  }

  upadteInventory = (data) => {
    return this.init().put(`/admin/updateInventory/${data?.id}`, data.values)
  }

  deletemultipleProducts = (ids) => {
    return this.init().post(`/admin/deleteProducts`, ids)
  }

  deleteAllProduct = (data) => {
    return this.init().delete("/admin/deleteAllProduct", { data });
  }
  //---------------------------------------------------sample request---------------------------------------

  getAllSamplerequest = (config) => {
    return this.init().get(`/admin/sample-request/get-all${config}`)
  }
  getSamplerequestDetails = (id) => {
    return this.init().get(`/admin/sample-request/${id}`)
  }

  updatesampleRequestStatus = (data) => {
    return this.init().put(`/admin/sample-request/update-status/${data.id}`, { status: data.status })
  }

  deleteSampleRequest = (id) => {
    return this.init().delete(`/admin/sample-request/${id}`)
  }


  //----------------------------------------------------order----------------------------------------------

  getAllOrder = (config) => {
    return this.init().get(`/admin/cart-order${config}`)
  }

  getOrderStatistics = () => {
    return this.init().get('/admin/statistics/cart-order')
  }

  getOrderDetails = (id) => {
    return this.init().get(`/admin/cart-order/${id}`)
  }

  deleteorder = (id) => {
    return this.init().delete(`/admin/cart-order/${id}`)
  }

  updatOrderStatus = (data) => {
    return this.init().put(`/admin/cart-order/update-status/${data.id}`, { status: data.status })
  }

  //scheduleenq----------------------------------------------------------------------------------------------

  getAllScheduleEnq = (config) => {
    return this.init().get(`/admin/schedule-enquiry${config}`)
  }

  getScheduleEnqStatistics = () => {
    return this.init().get('/admin/statistics/schedule-enquiry')
  }


  getScheduleDetails = (id) => {
    return this.init().get(`/admin/schedule-enquiry/${id}`)
  }

  deleteScheduleEnq = (id) => {
    return this.init().delete(`/admin/schedule-enquiry/${id}`)
  }

  updateScheduleStatus = (data) => {
    return this.init().put(`/admin/schedule-enquiry/update-status/${data.id}`, data)
  }


  deleteProductFromenq = (data) => {
    return this.init().put(`/admin/schedule-enquiry/remove-product/${data?.id}`, data)
  }

  updateProductFromenq = (data) => {
    return this.init().post(`/admin/schedule-enquiry/approve/${data?.id}`, data)
  }

  updateScheduleEnquiryProduct = (data) => {
    return this.init().put(`/admin/schedule-enquiry/update-product/${data?.id}`, data)
  }

  getMatchedProducts = (data) => {
    return this.init().post("/common/bom/matchproducts", { data })
  }

  getExactSearch = (data) => {
    return this.init().get(`/common/crossReference/exactSearch${data}`)
  }

  // scheduled order

  getAllScheduledOrder = (data) => {
    return this.init().get(`/admin/schedule-order?${data}`)
  }

  getScheduleOrderStatistics = () => {
    return this.init().get('/admin/statistics/schedule-order')
  }

  approveScheduleOrders = (orderId) => {
    return this.init().post(`/admin//schedule-order/approve/${orderId}`)
  }

  approveScheduleEnquiry = (orderId) => {
    return this.init().post(`/admin/schedule-enquiry/approve/${orderId}`)
  }

  dispatchScheduleOrder = (data) => {
    return this.init().put(`/admin/dispatchScheduleOrder/${data?.id}`, data)
  }

  confirmDelivery = (data) => {
    return this.init().put(`/admin/updateScheduleOrderStatus/${data?.id}`, data)
  }

  createScheduleenquiry = (data) => {
    return this.init().post(`/admin/admincreatescheduleenquiry`, data)
  }

  //vendor enquiry----------------------------------------------------------------
  //-----------------------------------------

  //vendor enquiry----------------------------------------------------------------
  //-----------------------------------------

  getSuppliers = (data) => {
    return this.init().get(`/admin/getSuppliers${data}`)
  }

  sendEnquiry = (data) => {
    return this.init().post(`/admin/vendorEnquiry`, data)
  }

  createOrder = (data) => {
    return this.init().post(`/admin/createPoOrder`, data)
  }

  //bom enq--------------------------------------------------------------------------------
  //----------------------------


  getAllbomEnq = (config) => {
    return this.init().get(`/admin/bomenquiry${config}`)
  }

  getBomEnqStatistics = () => {
    return this.init().get('/admin/bom/getBomEnquiryStatistics')
  }

  getbomDetails = (id) => {
    return this.init().get(`/admin/bomenquiry/${id}`)
  }

  deleteBomEnq = (id) => {
    return this.init().put(`/admin/trashbomenquiry/${id}`, {
      status: true
    })
  }

  updatebomStatus = (data) => {
    return this.init().put(`/admin/bomenquiry/${data.id}`, data)
  }

  deleteProductFrombomenq = (data) => {
    return this.init().put(`/admin/deletePartFromBom/${data?.id}`, data)
  }


  updateProductFrombomenq = (data) => {
    return this.init().put(`/admin/updatePartInBom/${data?.id}`, data)
  }

  createBomQoute = (data) => {
    return this.init().put(`/admin/createBomQuote/${data?.id}`, data.data)
  }

  getBomAlternateProducts = (data) => {
    return this.init().get(`/common/bom/getProductWithAlternates${data}`)
  }

  //bom order--------------------------------------------------------------------------------
  //----------------------------


  getAllbomOrder = (config) => {
    return this.init().get(`/admin/bomorder${config}`)
  }

  getBomOrderStatistics = (config) => {
    return this.init().get(`/admin/bom/getBomOrderStatistics${config}`)
  }

  getbomOrderDetails = (id) => {
    return this.init().get(`/admin/bomorder/${id}`)
  }

  deleteBomOrder = (id) => {
    return this.init().put(`/admin/trashbomorder/${id}`, {
      status: true
    })
  }

  updatebomOrderStatus = (data) => {
    return this.init().put(`/admin/bomorder/${data.id}`, data)
  }


  //Vendor order--------------------------------------------------------------------------------
  //----------------------------


  getAllVendorOrder = (config) => {
    return this.init().get(`/admin/vendororder${config}`)
  }

  getVendorOrderStatistics = (config) => {
    return this.init().get(`/admin/getVendorOrderStatistics${config}`)
  }

  getVendorOrderDetails = (id) => {
    return this.init().get(`/admin/vendororder/${id}`)
  }

  deleteVendorOrder = (id) => {
    return this.init().put(`/admin/trashvendororder/${id}`, {
      status: true
    })
  }

  updateVendorOrderStatus = (data) => {
    return this.init().put(`/admin/vendororder/${data.id}`, data)
  }



  //wizard enq--------------------------------------------------------------------------------
  //----------------------------


  getAllwizardEnq = (config) => {
    return this.init().get(`/admin/wizard${config}`)
  }

  getwizardEnqStatistics = () => {
    return this.init().get('/admin/getWizardEnquiryStatistics')
  }

  getwizardDetails = (id) => {
    return this.init().get(`/admin/wizard/${id}`)
  }

  deletewizardEnq = (id) => {
    return this.init().put(`/admin/trashWizardEnquiry/${id}`, {
      status: true
    })
  }

  updatewizardStatus = (data) => {
    return this.init().put(`/admin/wizardenquiry/${data.id}`, data)
  }

  deleteProductFromwizardenq = (data) => {
    return this.init().put(`/admin/deletePartFromWizard/${data?.id}`, data)
  }

  updateProductFromwizardenq = (data) => {
    return this.init().put(`/admin/updatePartInwizard/${data?.id}`, data)
  }

  createwizardQoute = (data) => {
    return this.init().put(`/admin/createwizardQuote/${data?.id}`, data.data)
  }

  getWizardAlternateProducts = (data) => {
    return this.init().get(`/common/wizard/getProductWithAlternates${data}`)
  }


  //wizard order--------------------------------------------------------------------------------
  //----------------------------


  getAllwizardOrder = (config) => {
    return this.init().get(`/admin/wizardorder${config}`)
  }

  getwizardOrderStatisticsdata = (config) => {
    return this.init().get(`/admin/wizardorderStatistics${config}`)
  }

  getwizardOrderDetails = (id) => {
    return this.init().get(`/admin/wizardorder/${id}`)
  }

  deletewizardOrder = (id) => {
    return this.init().put(`/admin/trashwizardorder/${id}`, {
      status: true
    })
  }

  updatewizardOrderStatus = (data) => {
    return this.init().put(`/admin/wizardorder/${data.id}`, data)
  }



  //EXCESS enq--------------------------------------------------------------------------------
  //----------------------------


  getAllexcessEnq = (config) => {
    return this.init().get(`/admin/excessinventory/getAllExcessInventoryEnquiries${config}`)
  }

  getexcessEnqStatistics = () => {
    return this.init().get('/admin/excessinventory/getexcessinventorystatistics')
  }

  getexcessDetails = (id) => {
    return this.init().get(`/admin/excessinventory/getExcessInventoryEnquiries/${id}`)
  }

  deleteexcessEnq = (id) => {
    return this.init().put(`/admin/excessinventory/trashExcessInventoryEnquiry/${id}`, {
      status: true
    })
  }

  updateexcessStatus = (data) => {
    return this.init().put(`/admin/excessinventory/excessenquiry/${data.id}`, data)
  }

  deleteProductFromexcessenq = (data) => {
    return this.init().put(`/admin/excessinventory/deletePartFromExcessInventory/${data?.id}`, data)
  }

  updateProductFromexcessenq = (data) => {
    return this.init().put(`/admin/excessinventory/updatePartInExcessInventory/${data?.id}`, data)
  }

  createexcessQoute = (data) => {
    return this.init().put(`/admin/excessinventory/createExcessInventoryQuote/${data?.id}`, data.data)
  }

  getExcessAlternateProducts = (data) => {
    return this.init().get(`/common/excessinventory/excess/getProductWithAlternates${data}`)
  }


  //excess order--------------------------------------------------------------------------------
  //----------------------------


  getAllexcessOrder = (config) => {
    return this.init().get(`/admin/excessinventory/order/getAllExcessInventoryOrders${config}`)
  }

  getexcessOrderStatisticsdata = (config) => {
    return this.init().get(`/admin/excessinventory/order/getExcessInventoryOrderStatistics${config}`)
  }

  getexcessOrderDetails = (id) => {
    return this.init().get(`/admin/excessinventory/order/getExcessInventoryOrderDetails/${id}`)
  }

  deleteexcessOrder = (id) => {
    return this.init().put(`/admin/excessinventory/order/trashExcessInventoryOrder/${id}`, {
      status: true
    })
  }

  updateexcessOrderStatus = (data) => {
    return this.init().put(`/admin/excessinventory/order/updateExcessInventoryOrderStatus/${data.id}`, data)
  }

  //---------------------------------------------vendorexcess---------------
  //---------------------------------

  getAllvendorExcess = (config) => {
    return this.init().get(`/admin/excessinventory/getAllvendorExcessInventory${config}`)
  }

  getvendorExcessStatisticsdata = (config) => {
    return this.init().get(`/admin/excessinventory/getvendorExcessInventoryStatistics`)
  }

  getvendorExcessDetails = (id) => {
    return this.init().get(`/admin/excessinventory/vendorExcessInventoryDetails/${id}`)
  }

  deleteProductFromvendorExcess = (data) => {
    return this.init().put(`/admin/excessinventory/deletePartFromvendorExcessInventory/${data?.id}`, data)
  }

  updatevendorExcessStatus = (data) => {
    return this.init().put(`/admin/excessinventory/updatevendorExcessInventoryStatus/${data.id}`, data)
  }

  deletevendorExcess = (id) => {
    return this.init().put(`/admin/excessinventory/trashvendorExcessInventory/${id}`, {
      status: true
    })
  }

  //---------------------------------------------------common----------------------------------------------

  getCategoryHeirarchy = (data) => {
    return this.init().get("/common/getCategoryHeirarchy", data)
  }

  bulkUploadProduct = (data) => {
    return this.init("multipart/form-data").post("/admin/bulkupload/product", data, { timeout: 300000 })
  }

  //--------------------------------------------------adminuser--------------------------------------------------

  //getAllCategory
  getAllAdmin = (config) => {
    return this.init().get(`/admin/getAdmin${config}`)
  }

  exportAdmin = () => {
    return this.init().get('/admin/exportAdmin')
  }


  addAdminUser = (data) => {
    return this.init().post('/admin/createadminUser', data)
  }

  getAdminDetails = (id) => {
    return this.init().get(`/admin/getSingleAdmindetails/${id}`)
  }

  deleteAdminUser = (id) => {
    return this.init().delete(`/admin/deleteAdmin/${id}`)
  }

  updatepassword = (data) => {
    return this.init().put(`/admin/changePassword/${data.id}`, {
      ...data?.values,
      logoutAllDevices: true,
    })
  }

  editAdmin = (data) => {
    return this.init().put(`/admin/editAdmin/${data.id}`, data?.values)
  }

  updateSettings = (data) => {
    return this.init().put(`/admin/updateSettings`, data)
  }

  //rights-------------------------------------------
  //-----------------------------
  getAdminPermissions = (config) => {
    return this.init().get(`/admin/getAllAdminPermissions`)
  }

  updateAdminPermissions = (data) => {
    return this.init().put(`/admin/updateAdminPermissions`, data)
  }
  //--------------------------------------------------------appearences------------------------------------

  addHeroBanner = (data) => {
    return this.init().post(`/admin/appearance/hero-banner`, data)
  }

  addLoginBuilder = (data) => {
    return this.init().post(`/admin/appearance/login-banner`, data)
  }
  addSlider = (data) => {
    return this.init().post(`/admin/appearance/slider`, data)
  }

  addTopCategories = (data) => {
    return this.init().post(`/admin/appearance/category`, { categories: data })
  }

  addTopProducts = (data) => {
    return this.init().post(`/admin/appearance/popular-product`, data)
  }

  deleteTopProducts = (productnumber) => {
    return this.init().delete(`/admin/appearance/popular-product/${productnumber}`)
  }

  getBanner = (data) => {
    return this.init().get('/admin/appearance/hero-banner')
  }

  getSlider = (data) => {
    return this.init().get('/admin/appearance/slider')
  }

  getTopCategories = (data) => {
    return this.init().get('/admin/appearance/category')
  }

  getTopProducts = (data) => {
    return this.init().get('/admin/appearance/popular-product')
  }

  getFeaturedBrand = () => {
    return this.init().get("/admin/appearance/popular-brand")
  }

  addFeaturedBrand = (data) => {
    return this.init().post("/admin/appearance/popular-brand", data)
  }

  getLoginBuilder = (data) => {
    return this.init().get('/admin/appearance/login-banner')
  }

  // notification
  getNotification = (data, showAll) => {
    return this.init().get(`/common/get-unreadmessages/${data}?showAll=${showAll}`)
  }
  markAsRead = (data) => {
    return this.init().put(`/common/mark-read-message/${data}`)
  }
  markAllAsReaded = (data) => {
    return this.init().put(`/common/mark-all-as-read/${data}`)
  }
  getNotificationCount = () => {
    return this.init().get(`/common/get-unread-count`)
  }

  smartSearch = (data) => {
    return this.init().get(`/user/smartsearch${data}`)
  }

}

const api = new Api();

export default api
